import { useEffect, useRef } from 'react'

const useOnceEffect = (cb, condition) => {
  const isCalledRef = useRef(false)

  useEffect(() => {
    if (condition && !isCalledRef.current) {
      isCalledRef.current = true
      cb()
    }
  }, [cb, condition])
}

export default useOnceEffect
